import moment from "jalali-moment";
import { toMoneyFormat } from "utils";

export const unixToShamsi = unix => {
    if (unix)
        return moment.unix(unix).format("hh:mm:ss jYYYY/jMM/jDD");

    throw Object.assign(
        new Error("no value"),
        { code: 402 }
    );
}

const convertUtils = (fn, value) => {
    try {
        switch (fn) {
            case "unixToShamsi":
                return unixToShamsi(value);
            case "toMoneyFormat":
                return toMoneyFormat(value);
            default:
                return "---";
        }
    } catch (e) {
        return "---";
    }
}

export default convertUtils;